import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=5b0372b1&scoped=true"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js"
import style0 from "./LanguageSwitcher.vue?vue&type=style&index=0&id=5b0372b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0372b1",
  null
  
)

export default component.exports